import React, { Component, useState, useEffect} from 'react';
import { types as sdkTypes } from '../../util/sdkLoader';
import css from './UploadPicture.module.css';
const sharetribeSdk = require('sharetribe-flex-sdk');


const sdk = sharetribeSdk.createInstance({
    clientId: process.env.REACT_APP_SHARETRIBE_SDK_CLIENT_ID
  });

const { UUID, LatLng } = sdkTypes;

export default function UploadPicture() {
  const [image, setImage] = useState({ preview: "", raw: "" });
  const [imageUrl, setImageUrl] = useState(null);

  useEffect(() => {

   sdk.currentUser.show().then(res => {
        const userImageLink = res.data.data.attributes.profile.publicData.profileImageLink;
        if(userImageLink){
            setImageUrl(userImageLink)
        }
      });
}
, []);

  const handleChange = e => {

    if (e.target.files.length) {
            const image = e.target.files[0];
                setImage({
                    preview: URL.createObjectURL(e.target.files[0]),
                    raw: e.target.files[0]
                });

                return sdk.images.upload({
                    image: image
                }, {
                    expand: true
                }).then(res => {
                    const imageId = res.data.data.id.uuid;
                    const imageLink = res.data.data.attributes.variants.default.url;
                    return sdk.currentUser.updateProfile({
                                profileImageId: new UUID(imageId),
                                publicData: {
                                    profileImageLink: imageLink
                                  },
                            }, {
                                expand: true,
                                include: ["profileImage"]
                            }).then(res => {

                                return sdk.ownListings.query({}).then(res => {
                                    const listingsArray = res.data.data;
                                    const masterCalProperty =  listingsArray.find(listing => {
                                        return listing.attributes.publicData.listingType === "masterListing"
                                        });
                                        return masterCalProperty
                                  });


                            }).catch(error => console.log(error));
                            
                        }).catch(error => console.log(error));

    }


  };

  const handleUpload = async e => {
    e.preventDefault();
    const formData = new FormData();
    formData.append("image", image.raw);

    await fetch("YOUR_URL", {
      method: "POST",
      headers: {
        "Content-Type": "multipart/form-data"
      },
      body: formData
    });
  };
  return (
    <div className={css.uploadImageRoot}>
      <label htmlFor="upload-button">
        {image.preview ? (
          <img className={css.imagePreview} src={image.preview} alt="dummy" width="300" height="300" />
        ) : (
          <>
            
            {imageUrl ? <img className={css.userImage} src={imageUrl} /> :
                <div>
                    <span className="fa-stack fa-2x mt-3 mb-2">
                    <i className="fas fa-circle fa-stack-2x" />
                    <i className="fas fa-store fa-stack-1x fa-inverse" />
                </span>
                <div className={css.uploadImageWrapper}>
                <span className={css.uploadImageText}>Upload your photo</span>
                </div>
                </div>
            }
          </>
        )}
      </label>
      <input
        type="file"
        id="upload-button"
        style={{ display: "none" }}
       
        onChange={handleChange}
      />
      <br />
      <button  className={css.uploadImageButton} onClick={handleUpload}>Upload</button>
    </div>
  );
}